import {VirtualTrayActionTypes} from '../../constants/actionType';

export const AspirateDispenseVolumeModalDefaultProps = {
  isShown: false,
  initialTipVolume: 0,
  initialTaskType: '',
  volume: 0,
  taskType: '',
  minVolume: 0,
  maxVolume: 0,
  tipVolumeSequence: {},
  onApplyCallback: () => {},
  position: {x: 0, y: 0},
};

const initialState = {
  focusedDeckNumber: null,
  deckLabwareRefs: null,
  aspirateDispenseVolumeModal: AspirateDispenseVolumeModalDefaultProps,
  shownModal: '',
};

const actions = {
  [VirtualTrayActionTypes.SET_FOCUSED_DECK_NUMBER]: (state, action) => ({
    ...state,
    focusedDeckNumber: action.deckNumber,
  }),
  [VirtualTrayActionTypes.SET_DECK_LABWARE_REFS]: (state, action) => ({
    ...state,
    deckLabwareRefs: action.deckLabwareRefs,
  }),
  [VirtualTrayActionTypes.SET_ASP_DISP_VOLUME_MODAL]: (state, action) => ({
    ...state,
    aspirateDispenseVolumeModal: action.volumeModalData,
  }),
  [VirtualTrayActionTypes.RESET_ASP_DISP_VOLUME_MODAL]: (state) => ({
    ...state,
    aspirateDispenseVolumeModal: AspirateDispenseVolumeModalDefaultProps,
  }),
  [VirtualTrayActionTypes.SET_SHOWN_MODAL]: (state, action) => ({...state, shownModal: action.shownModal}),
  [VirtualTrayActionTypes.RESTORE_VIRTUAL_TRAY_STATE]: (state, action) => action.state,
  [VirtualTrayActionTypes.RESET_VIRTUAL_TRAY_STATE]: () => initialState,
};

export default function virtualTrayStateReducer(state = initialState, action = '') {
  const {type} = action;
  const func = actions[type];

  return func ? func(state, action) : state;
}
